import { Component, OnInit } from '@angular/core';
import { BillersService } from '../../../services/billers.service';
import { Router } from '@angular/router';
import { CommonService } from '../../../services/common.service';
import { SendMoneyService } from '../../send-money/send-money.service';
import { AuthService } from 'src/app/services/auth.service';
import { ConfirmationService, ConfirmEventType, MessageService } from 'primeng/api';

declare var webengage
@Component({
  selector: 'app-biller1',
  templateUrl: './biller1.component.html',
  styleUrls: ['./biller1.component.scss'],
})
export class Biller1Component implements OnInit {
  billers = [];
  start = 0;
  selectedBiller;
  current_page
  last_page
  prev_disabled
  next_disabled

  constructor(
    public billerService: BillersService,
    public router: Router,
    public common: CommonService,
    public sendMoney: SendMoneyService,
    public auth: AuthService,
    public messageService: MessageService,
    public confirmationService: ConfirmationService
  ) { }

  ngOnInit(): void {
    // setTimeout(()=>{
    //   this.selectedBiller = this.billerService.biller
    // },2000)
    this.common.showLoader();
    this.billerService.details = false;
    this.getBillers(1)
    webengage.track("pay_bill_initiate", {})
  }

  getBillers(page) {
    this.common.showLoader()
    this.billerService.getUserBillers(page).subscribe(
      (res: any) => {
        this.billers = res.data.data;
        this.current_page = res.data.current_page
        this.last_page = res.data.last_page
        if (this.current_page == 1)
          this.prev_disabled = true
        else
          this.prev_disabled = false

        if (this.current_page == this.last_page)
          this.next_disabled = true
        else
          this.next_disabled = false
        this.common.stopLoader();
      },
      (err) => {
        //console.log(err);
        this.common.stopLoader();
      }
    );
  }

  selectBiller(biller) {
    this.selectedBiller = biller;
    this.billerService.biller = this.selectedBiller;
    webengage.track('biller_select', {
      country: biller.country_name,
      biller: biller.biller_name
    })
  }

  checkAndProceed() {
    this.common.showLoader();
    this.billerService.fetchBill(this.selectedBiller['id'])
      .subscribe((res) => {
        if (+res['data'].amount_due != 0) {
          this.billerService.finalData = {
            ...this.billerService.finalData,
            ...{ biller_amount_local: res['data'].amount_due },
          };

          this.billerService
            .getBillAmount(
              this.selectedBiller.currency.toLowerCase(),
              this.billerService.finalData['biller_amount_local']
            )
            .subscribe((res) => {
              this.billerService.finalData = {
                ...this.billerService.finalData,
                ...{
                  amount_cad: res['destination_amount_cad'],
                  amount_usd: res['destination_amount_usd'],
                  exchange_rate_cad: (
                    (res['destination_amount_usd'] *
                      res['currency_conversion_rate']) /
                    res['destination_amount_cad']
                  ).toFixed(2),
                  exchange_rate_usd: res['currency_conversion_rate'],
                },
              };
              webengage.track('pay_bill_details', {
                due: true,
                amount: +this.billerService.finalData.amount_cad,
                currency: 'CAD'
              })
              this.sendMoney
                .getTransactionFees(
                  this.auth.user.currency,
                  this.selectedBiller.currency.toLowerCase(),
                  this.billerService.finalData['exchange_rate_cad']
                )
                .subscribe((res) => {
                  this.billerService.finalData = {
                    ...this.billerService.finalData,
                    ...{
                      transaction_fees: 0,
                    },
                  };
                  this.common.stopLoader();
                });
            });
          this.billerService.nextPage('biller2');
        } else {
          this.billerService.message.add({
            severity: 'info',
            summary: 'No Dues',
            detail: 'You have no pending bills!',
          });
          webengage.track('pay_bill_details', {
            due: false
          })
          this.common.stopLoader();
        }
      });
  }

  removeBiller(id) {
    this.billerService.RemoveBiller(id).subscribe((res) => {
      if (res['result']) {
        this.billerService.message.add({
          severity: 'success',
          summary: 'Deleted',
          detail: 'Successfully deleted biller',
        });
        // window.location.reload();
        this.getBillers(1)
      }
    });
  }

  prev() {
    this.start -= 5;
  }
  next() {
    this.start += 5;
  }

  disableNext() {
    if (this.billers.length <= 5)
      return true
    else {
      if (this.billers.length % 5 == 0) {
        return parseInt((this.billers.length / 5).toString()) == (this.start + 5) / 5
          ? true
          : false;
      }
      else {
        return parseInt((this.billers.length / 5).toString()) == (this.start) / 5
          ? true
          : false;
      }
    }

  }

  show() {
    if (this.last_page == 1) {
      return true
    }
    else {
      return false
    }
  }

  confirmDelete(id) {
    //console.log("HELLO")
    this.confirmationService.confirm({
      message: 'Are you sure that you want delete the biller?',
      header: 'Confirmation',
      accept: () => {
        // this.messageService.add({severity:'info', summary:'Confirmed', detail:'You have successfully deleted biller.'});
        this.removeBiller(id)
      },
      reject: (type) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected' });
            break;
          case ConfirmEventType.CANCEL:
            this.messageService.add({ severity: 'warn', summary: 'Cancelled', detail: 'You have cancelled' });
            break;
        }
      }
    });
  }
}
